/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svchip_WebhooksInputs */

const en_svchip_webhooks = /** @type {(inputs: Svchip_WebhooksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Webhooks`)
};

const ar_svchip_webhooks = /** @type {(inputs: Svchip_WebhooksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`خطافات الويب`)
};

const bn_svchip_webhooks = /** @type {(inputs: Svchip_WebhooksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ওয়েবহুক`)
};

const de_svchip_webhooks = /** @type {(inputs: Svchip_WebhooksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Webhooks`)
};

const es_svchip_webhooks = /** @type {(inputs: Svchip_WebhooksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Webhooks`)
};

const fr_svchip_webhooks = /** @type {(inputs: Svchip_WebhooksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Webhooks`)
};

const pt_svchip_webhooks = /** @type {(inputs: Svchip_WebhooksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Webhooks`)
};

const zh_svchip_webhooks = /** @type {(inputs: Svchip_WebhooksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Webhook`)
};

const tr_svchip_webhooks = /** @type {(inputs: Svchip_WebhooksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Web Kancaları`)
};

const ru_svchip_webhooks = /** @type {(inputs: Svchip_WebhooksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вебхуки`)
};

const pl_svchip_webhooks = /** @type {(inputs: Svchip_WebhooksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Webhooki`)
};

/**
* | output |
* | --- |
* | "Webhooks" |
*
* @param {Svchip_WebhooksInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svchip_webhooks = /** @type {((inputs?: Svchip_WebhooksInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svchip_WebhooksInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svchip_webhooks(inputs)
	if (locale === "bn") return bn_svchip_webhooks(inputs)
	if (locale === "de") return de_svchip_webhooks(inputs)
	if (locale === "es") return es_svchip_webhooks(inputs)
	if (locale === "fr") return fr_svchip_webhooks(inputs)
	if (locale === "pt") return pt_svchip_webhooks(inputs)
	if (locale === "zh") return zh_svchip_webhooks(inputs)
	if (locale === "tr") return tr_svchip_webhooks(inputs)
	if (locale === "ru") return ru_svchip_webhooks(inputs)
	if (locale === "pl") return pl_svchip_webhooks(inputs)
	return en_svchip_webhooks(inputs)
});